import "./App.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home/Home";
import HomeNew from "./components/Home/HomeNew";
import About from "./components/About/About";
import ContactPage from "./components/Contact/ContactPage";
import Itinerary from "./components/Itinerary/Itinerary";
import TourTrips from "./components/Tours/TourTrips";
import PlanATrip from "./components/PlanATrip/PlanATRip";
import TourTripPdf from "./components/Tours/TourTripPdf";
import TourDetails from "./components/Tours/TourDetails";
import TourTripEnrollment from "./components/Tours/TourTripEnrollment";
import Vehicles from "./components/VIP/Vehicles/Vehicles";
import Gallery from "./components/Gallery/Gallery";
import ViewGallery from "./components/Gallery/ViewGallery";
import FaqPage from "./components/FAQ/FaqPage";
import ThankYou from "./components/Tours/ThankYou";
import ClaimForm from "./components/Tours/ClaimForm";
import InfoPage from "./components/Tours/InfoPage";
import ClaimStatus from "./components/Tours/ClaimStatus";
import TravelInsurance from "./components/Tours/TravelInsurance";
import Modal from "react-modal";

import BookVehicleForm from "./components/Tours/BookVehicleForm";
import VehicleDetails from "./components/VIP/Vehicles/VehicleDetails";
import BookVehicleForm1 from "./components/Tours/BookingVehicleForm1";
import VehicleBookingStatus from "./components/Tours/VehicleBookingStatus";
import CustomizeItinerary from "./components/Itinerary/CustomizeItinerary";
import OldItinerary from "./components/Itinerary/OldItinerary";
import Itinerary2 from "./components/Itinerary/Itinerary2";
import RedirectDocusign from "./components/Tours/RedirectDocusign";
import EnquiryStatus from "./components/Tours/EnquiryStatus";
import ViewEnquiryStatus from "./components/Tours/ViewEnquiryStatus";
import VacationList from "./components/Tours/VacationList";
import IndivisualVacation from "./components/Tours/IndivisualVacation";
import Flights from "./components/Flight/Flights";
import PageNotFound from "./components/pageNotFound/PageNotFound";
import NewFlightSearch from "./components/NewFlightSearch/NewFlightSearch";
import TravelInsurancePayment from "./components/Tours/TravelInsurancePayment";
import TravelInsurancePlans from "./components/Tours/TravelInsurancePlans";
import FlightLiveTracking from "./components/FlightStats/FlightLiveTracking/FlightLiveTracking";
import FlightTracking from "./components/FlightStats/FlightSchedule/FlightTracking";
import FlightWeather from "./components/FlightStats/AirportWeather/FlightWeather";
import DelayStatistics from "./components/FlightStats/DelayStatistics/DelayStatistics";
import NewTravelInsurance from "./components/TravelInsurance/TravelInsurance";
import FlightStatsDetails from "./components/FlightStats/FlightSchedule/FlightStatsDetails";


Modal.setAppElement("#root");
function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeNew />} />
      <Route path="/contact" element={<ContactPage />} />
      {/* <Route path="/itinerary" element={<Itinerary />} />
       */}
      {/* <Route path="/itinerary" element={<OldItinerary />} /> */}
      <Route path="/itinerary" element={<Itinerary2 />} />

      <Route
        path="/customize-itinerary/:booking_id"
        element={<CustomizeItinerary />}
      />

      <Route path="/thank-you-page" element={<ThankYou />} />
      <Route path="/thank-you" element={<RedirectDocusign />} />

      <Route path="/vehicle-request" element={<BookVehicleForm />} />
      <Route
        path="/vehicle-book-request/:vehicle_id"
        element={<BookVehicleForm1 />}
      />
      <Route
        path="/view-vehicle-detail/:vehicle_id"
        element={<VehicleDetails />}
      />
      <Route path="/view-tours/:category_id" element={<TourTrips />} />
      <Route path="/tour/:tour_pdf_name" element={<TourTripPdf />} />
      <Route path="/winter-vacation" element={<VacationList />} />
      <Route path="/summer-vacation" element={<VacationList />} />
      <Route
        path="/vacation-details/:vacation_id"
        element={<IndivisualVacation />}
      />
      <Route
        path="/view-tour-Enrollment/:tour_Enrollment_id"
        element={<TourTripEnrollment />}
      />
      <Route path="/enquiry-status" element={<EnquiryStatus />} />
      <Route path="/flights" element={<NewFlightSearch />} />
      <Route
        path="/view-enquiry-status/:enquiry_id"
        element={<ViewEnquiryStatus />}
      />

      <Route path="/view-tour-details/:tour_id" element={<TourDetails />} />
      <Route path="/plan-a-trip" element={<PlanATrip />} />
      <Route path="/vehicles" element={<Vehicles />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/view-gallery/:gallery_id" element={<ViewGallery />} />
      <Route path="/faq" element={<FaqPage />} />

      <Route
        path="/vehicle-booking-status"
        element={<VehicleBookingStatus />}
      />

      <Route path="/insurance" element={<NewTravelInsurance />} />
      <Route path="/insurance/payment" element={<TravelInsurancePayment />} />
      <Route path="/insurance/plans" element={<TravelInsurancePlans />} />
      {/* <Route path="/claim" element={<ClaimForm />} />
      <Route path="/claimstatus" element={<ClaimStatus />} />
      <Route path="/info" element={<InfoPage />} /> */}

      {/* <Route path="/flight-live-tracking" element={<FlightLiveTracking />} /> */}
      <Route path="/flight-schedule" element={<FlightTracking />} />
      <Route path="/airport-weather" element={<FlightWeather />} />
      <Route path="/airport-delay" element={<DelayStatistics />} />
      <Route path="/flight-details/:id" element={<FlightStatsDetails />} />
          <Route element={<FlightStatsDetails />} path="/flight-live-tracking" />



      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
